import { AppRoutes } from "@/types/domain";
import { popupCenter } from "@/utils/popup";

// Mirrors the mainSearch popup logic from Index.Master.js
export const openSearchLookup = (routes: AppRoutes, searchType: string, searchText: string, searchDesc: string) => {
  const target = `&showselect=true&IMLASTSEARCH=${searchType}${searchText ? `&srchtxt=${encodeURIComponent(searchText)}` : ""}`;
  const [searchField, searchIndex] = searchType.split("_");

  const popup = (url: string) => popupCenter(url, "_blank", 1024, 768);

  switch (searchField) {
    case "Contact":
      popup(`${routes.contactLookup}?ID=Contact${target}&fieldIndex=${searchIndex ?? ""}`);
      break;
    case "Product":
      popup(`${routes.productLookup}?ID=Product${target}`);
      break;
    case "ProductGroup":
    case "Product Group":
      popup(`${routes.prodGrpLookup}?ID=ProductGroup${target}`);
      break;
    case "Alert":
      popup(`${routes.alertLookup}?ID=Alert${target}`);
      break;
    case "Customer":
    case "Company":
      popup(`${routes.companyLookup}?source=&ID=Dashboard.aspx${target}&fieldIndex=${searchIndex ?? ""}`);
      break;
    case "ProjectName":
      window.location.assign(`${routes.root}Project?search=${encodeURIComponent(searchText)}`);
      break;
    case "ProjectNumber":
      window.location.assign(`${routes.root}Project?number=${encodeURIComponent(searchText)}`);
      break;
    case "OpportunityName":
      window.location.assign(`${routes.root}Pipeline/Search?search=${encodeURIComponent(searchText)}`);
      break;
    case "OpportunityNumber":
      window.location.assign(`${routes.root}Pipeline/Search?number=${encodeURIComponent(searchText)}`);
      break;
    default: {
      // Analysis types: HA=History, PA=Product, CA=Company
      const short = searchField.substring(0, 2);
      const analysisType = short === "HA" ? "History" : short === "PA" ? "Product" : "Company";
      const index = searchField.substring(2);
      popup(`${routes.analysisLookup}?AnalType=${analysisType}&index=${index}&desc=${encodeURIComponent(searchDesc)}&ID=Analysis|${analysisType}|${index}|${encodeURIComponent(searchDesc)}${target}`);
      break;
    }
  }
};
